import React from "react";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";

const ClientViewDocuments = ({ data }) => {
  return (
    <div className="card">
      <div className="card-header">
        <h2 className="page-title">View Documents</h2>
      </div>
      <div className="card-body">
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3">Client Name</label>
            <div className="w-100 col">
              {(data?.clientProject?.clientName || "N/A").toUpperCase()}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3">
              Aadhar card photo front
            </label>
            <div className="w-100 col">
              {data.aadharcardPhotoFront ? (
                <LazyImageComponent
                  width="70%"
                  src={data.aadharcardPhotoFront}
                  alt={"Aadhar card front"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}

        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3">
              Aadhar card photo back
            </label>
            <div className="w-100 col">
              {data?.aadharcardPhotoBack ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.aadharcardPhotoBack}
                  alt={"Aadhar card back"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}

        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3"> Work order</label>
            <div className="w-100 col">
              {data?.workOrder ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.workOrder}
                  alt={"Work order"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3"> Cibil report</label>
            <div className="w-100 col">
              {data?.cibilReport ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.cibilReport}
                  alt={"Cibil report"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3"> PAN Card</label>
            <div className="w-100 col">
              {data?.pancardPhoto ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.pancardPhoto}
                  alt={"pan card"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3"> ITR report</label>
            <div className="w-100 col">
              {data?.ITRReport ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.ITRReport}
                  alt={"ITR report"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3">Cast certificate</label>
            <div className="w-100 col">
              {data?.castCertificate ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.castCertificate}
                  alt={"Cast certificate"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3">Farmer certificate</label>
            <div className="w-100 col">
              {data?.farmerCertificate ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.farmerCertificate}
                  alt={"Farmer certificate"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
        {data && (
          <div className="mb-3 row">
            <label className="w-25 form-label col-3">Rental Documents</label>
            <div className="w-100 col">
              {data?.rentalDocuments ? (
                <LazyImageComponent
                  width="70%"
                  src={data?.rentalDocuments}
                  alt={"Rental Documents"}
                />
              ) : (
                "N/A"
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientViewDocuments;
